import Resource from "./resource";

export class CertificateConfigurationResource extends Resource {
    Name: string;
    Thumbprint: string;
    SignatureAlgorithm: string;
}

export default CertificateConfigurationResource;
